import {AccountModel} from '../../../../models/general/account.model';
import {MovementModel} from '../../../../models/general/movement.model';
import {
  SharedReportCategory,
  SharedReportDate,
  SharedReportSchedule,
  SharedReportTrends
} from '../../../../interfaces/shared.data.interface';
export interface FileDataShare{
    title: string,
    title2: string,
    accounts?: AccountModel[],
    fileType?: FileType,
    movements? : MovementModel[],
    reportCategory? : SharedReportCategory[],
    reportDate? : SharedReportDate[],
    reportTrend? : SharedReportTrends[],
    schedule? : SharedReportSchedule[],
}

export enum FileType{
    listMovements,
    reportByDates,
    reportByCategories,
    trendsCategories,
    schedule,
}

export enum FileExtension {
    xls = 'xlsx',
    csv = 'csv'
}
